import lf from 'localforage';

lf.config({
  driver: lf.LOCALSTORAGE,
  name: 'myApp',
  storeName: 'patient',
  version: 1.0,
});

// TODO: Repeated Code
export const storageService = {
  ACCESS_TOKEN: 'accessToken',
  user: 'user',
  CHAT_DATA: 'chatData',
  ShowAll: 'showAll',
  Whatsapp_Opt_In: 'isWhatsappOptedIn',
  get: async <T>(key: string): Promise<T | null> => lf.getItem<T>(key),
  set: async <T>(key: string, value: T): Promise<T> => lf.setItem<T>(key, value),
  remove: async (key: string): Promise<void> => lf.removeItem(key),
  clear: async (): Promise<void> => lf.clear(),
  length: async (): Promise<number> => lf.length(),
  key: async (keyIndex: number): Promise<string> => lf.key(keyIndex),
  keys: async (): Promise<string[]> => lf.keys(),
  iterate: async <T, U>(
    iteratee: (value: T, key: string, iterationNumber: number) => U,
  ): Promise<U> => lf.iterate<T, U>(iteratee),
};